/**
 *
 * Scroll Shadow (JS)
 *
 * @author Takuto Yanagida @ Space-Time Inc.
 * @version 2020-01-08
 *
 */


(function () {

	const SEL_CONTAINER = '.scroll-shadow';
	const CLS_SHADOW    = 'shadow';


	document.addEventListener('DOMContentLoaded', () => {
		const cs = document.querySelectorAll(SEL_CONTAINER);
		for (let i = 0; i < cs.length; i += 1) {
			const c = cs[i];
			const s = createShadow(c);
			c.addEventListener('scroll', ST.throttle(() => { updateShadow(c, s); }));
			ST.onResize(() => { updateShadow(c, s); }, true);
		}
	});


	// -------------------------------------------------------------------------


	function createShadow(cont) {
		const shadow = document.createElement('div');
		shadow.className           = CLS_SHADOW;
		shadow.style.position      = 'absolute';
		shadow.style.top           = '0';
		shadow.style.left          = '0';
		shadow.style.width         = '100%';
		shadow.style.height        = '100%';
		shadow.style.pointerEvents = 'none';

		cont.parentElement.style.position = 'relative';
		cont.parentElement.appendChild(shadow);
		return shadow;
	}

	function updateShadow(cont, shadow) {
		if (isScrollable(cont)) {
			shadow.style.background = calcShadowStyle(cont);
		} else {
			shadow.style.background = '';  // This must be '' for IE11
		}
	}

	function isScrollable(cont) {
		return (cont.scrollWidth - cont.clientWidth > 2);  // for avoiding needless scrolling
	}

	function calcShadowStyle(cont) {
		const r = cont.scrollLeft / (cont.scrollWidth - cont.clientWidth);
		let rl = 0.5, rr = 0.5;
		if (r < 0.1) rl *= r / 0.1;
		if (0.9 < r) rr *= (1 - r) / 0.1;
		const sl = `radial-gradient(farthest-side at  0px center, rgba(0,0,0,${rl}), rgba(0,0,0,0)) left top`;
		const sr = `radial-gradient(farthest-side at 1.25rem center, rgba(0,0,0,${rr}), rgba(0,0,0,0)) right top`;
		const size = ' / 1.25rem 3.25rem no-repeat scroll';
		return sl + size + ',' + sr + size;
	}

})();
